import React from 'react';
import classes from './Communities.module.scss';
import {SectionHeading, CallToAction} from 'components';
import slIcon from 'images/sl-icon.png';
import pteIcon from 'images/pte-icon.png';
import fiIcon from 'images/fi-icon.png';
import cacIcon from 'images/cac-icon.png';

const Communities = (props) => {
    const cacUrl = "https://www.meetup.com/coffee-code-philly";
    const pslUrl = "https://www.phillystartupleaders.org";
    const pteUrl = "https://phillytechentrepreneurs.com";
    const fiUrl = "https://fi.co";
    
    const openNewTab = (url) => {
        window.open(url, '_blank');
    };

    return (
        <div>
            <SectionHeading color="2E4C4D" header="Meet up within your local communities." subHeading="Your next match might be closer than you think."/>
            <div className={`${classes.communityCards}`}>
                <div className={`${classes.communityCard}`}>
                    <img src={cacIcon} onClick={() => openNewTab(cacUrl)}/>
                </div>
                <div className={`${classes.communityCard}`}>
                    <img src={slIcon} onClick={() => openNewTab(pslUrl)}/>
                </div>
                <div className={`${classes.communityCard}`}>
                    <img src={pteIcon} onClick={() => openNewTab(pteUrl)}/>
                </div>
                <div className={`${classes.communityCard}`}>
                    <img src={fiIcon} onClick={() => openNewTab(fiUrl)}/>
                </div>
            </div>
            <div className='join-now-wrapper gray-container'>
            <SectionHeading header={"Are you a community leader?"} subHeading={"We'd love to enhance your events!"}/>
            <CallToAction 
                actionButtonTitle="Let's talk" 
                userActionButtonTitle="Let's talk" 
                imageDesc="sidejawn partners connecting through startup"
            />
            </div>
        </div>
    );
    };

export default Communities;